import { type ReactNode } from 'react';

interface PanelEmptyProps {
  /** Explanatory copy — what this panel is and that it fills in as you chat. */
  children: ReactNode;
}

/** Shared empty-state placeholder for the inspector's Memory / Tools / Files
 *  sections. On a fresh session each is empty and otherwise unlabeled; this
 *  centered, muted note tells the user what the section is for. */
export default function PanelEmpty({ children }: PanelEmptyProps) {
  return (
    <div className="om-panel-empty">
      <p className="om-panel-empty__text">{children}</p>
    </div>
  );
}
